<template>
    <!-- Renders staging's slide-over while the reports redesign is gated off for this site, and the
         redesign's otherwise. Props and listeners fall through to whichever one renders. Delete with
         ReportsRedesignHelper, moving SlideOverPanelRedesign.vue back to this file. -->
    <component :is="redesign ? 'SlideOverPanelRedesign' : 'LegacySlideOverPanel'">
        <template v-for="(_, name) in $slots" #[name]="scope">
            <slot :name="name" v-bind="scope || {}"></slot>
        </template>
    </component>
</template>

<script>
import LegacySlideOverPanel from "@/components/elements/Legacy/LegacySlideOverPanel.vue"
import SlideOverPanelRedesign from "@/components/elements/SlideOverPanelRedesign.vue"

export default {
    name: "SlideOverPanel",
    components: {LegacySlideOverPanel, SlideOverPanelRedesign},
    data() {
        return {
            redesign: window.reportsRedesign === true,
        }
    },
}
</script>
